import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';

export const isAdminGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const nav = inject(NavigationService);

	const isAdmin: boolean = await authService.isAdmin$();

	if (isAdmin) {
		return true;
	} else {
		nav.navigate(['/']);
		return false;
	}
};
